import { DashboardIcon, Pencil1Icon } from "@radix-ui/react-icons";
import {
  Activity,
  Archive,
  Banknote,
  Box,
  Briefcase,
  Building,
  Calendar,
  ClipboardList,
  Clock,
  Coins,
  Folder,
  Gift,
  GraduationCap,
  HandCoins,
  Image,
  Languages,
  Layers,
  Lock,
  MapPin,
  MessageSquare,
  Megaphone,
  Percent,
  Plus,
  Receipt,
  Settings,
  Share2,
  Shield,
  Star,
  Store,
  Tag,
  Ticket,
  TrendingUp,
  Truck,
  User,
  Users,
  Power,
  RotateCcw,
  ScrollText,
  Wallet
} from "lucide-react";
export const mainIcons = {
  users: User,
  edit: Pencil1Icon,
  create: Plus,
  Dashboard: DashboardIcon,
  financialOverview: TrendingUp,
  activityLogs: ScrollText,
  languages: Languages,
  currency: Coins,
  banners: Image,
  fortuneWheel: RotateCcw,
  campaignsCenter: Megaphone,
  cities: Building,
  transactions: Banknote,
  stores: Store,
  category: Folder,
  categories: Folder,
  branches: MapPin,
  rating: Star,
  banks: Banknote,
  locations: MapPin,
  accounting: Banknote,
  modules: Settings,
  fund: Banknote,
  schedule: Clock,
  delivery: Truck,
  "users & access": User,
  content: Folder,
  withdraw: Banknote,
  "orders & support": ClipboardList,
  roles: Shield,
  permissions: Lock,
  orders: ClipboardList,
  archivedOrders: Archive,
  complaint: MessageSquare,
  services: Settings,
  products: Box,
  zones: MapPin,
  coupons: Ticket,
  Offers: Gift,
  variationTemplate: Folder,
  customers: Users,
  employees: Briefcase,
  socialMedia: Share2,
  academicContent: GraduationCap,
  systemSettings: Settings,
  settings: Settings,
  storeTemplates: Layers,
  customerCategories: Users,
  wallet: Wallet,
  "Driver Withdrawals": HandCoins,
  "Cash Settlements": Receipt
};

export const columnsIcons = {
  status: Power,
  title: Languages,
  code: Ticket,
  type: Tag,
  discountType: Percent,
  discountValue: Coins,
  maxUsage: Users,
  usageCount: Activity,
  minOrderAmount: Coins,
  startDate: Calendar,
  endDate: Calendar,
  minDiscountValue: Coins,
  maxDiscountValue: Coins,
  createdAt: Calendar
};

export type MainIconsType = keyof typeof mainIcons;
export type ColumnsIconsType = keyof typeof columnsIcons;
export type AllIconsType = MainIconsType | ColumnsIconsType;
